import "../legal/TermsOfUsePage.css";

const TermsOfUse = () => {
  return (
    <main className="legal-page">
      <div className="legal-page__container">
        <h1>Terms of Use</h1>
        <p>
          By accessing or using this website, you agree to the following terms.
          If you do not agree, please stop using the site.
        </p>

        <ol className="terms-sections">
          <li>
            <h2>No Guarantee of Service</h2>
            <p>
              Information on this website is provided on an "as available"
              basis. Accessing this site or submitting an enquiry does not
              guarantee acceptance, service availability, response timelines, or
              outcomes.
            </p>
          </li>
          <li>
            <h2>No Patient-Provider Relationship Until Confirmed</h2>
            <p>
              A patient-provider relationship is not created by browsing this
              website, sending a message, or submitting forms. Any relationship
              begins only after{" "}
              <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
                Rx Connect Specialty Pharmacy
              </a>{" "}
              confirms it through the appropriate process.
            </p>
          </li>
          <li>
            <h2>Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law,{" "}
              <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
                Rx Connect Specialty Pharmacy
              </a>{" "}
              is not liable for any direct, indirect, incidental, or
              consequential loss resulting from use of this website or reliance
              on its content.
            </p>
          </li>
          <li>
            <h2>Acceptable Use of Site</h2>
            <p>
              You agree not to misuse the site, attempt unauthorized access,
              disrupt services, submit false information, or use the site in any
              unlawful way.
            </p>
          </li>
        </ol>

        <h2>Contact</h2>
        <p>
          If you have questions about these terms, email{" "}
          <a href="mailto:info@sandyrandhawa.com">info@sandyrandhawa.com</a>.
        </p>
      </div>
    </main>
  );
};

export default TermsOfUse;
